import React, { Component } from 'react';

import { isEmpty } from '../../../Common/Common';

import Switch from '../../../Part_Sample/Switch';
import Select from '../../../Part_Sample/Select';
import Editbox from '../../../Part_Sample/Editbox';

export default class Command_RT extends Component {
	constructor(props) {
		super(props);

		this.min = 0;
		this.max = 32;
		this.condition_detail = JSON.parse(JSON.stringify(this.props.condition_detail));

		let value = this.min;
		let operator = '>';
		if (this.condition_detail.value.ofset != null) value = this.condition_detail.value.ofset;
		if (this.condition_detail.condition != null) operator = this.condition_detail.condition;

		let point_info = window.app.state.point_list[this.props.point_id];
		if (!isEmpty(point_info)) {
			if (point_info.temp_limit != null) {
				this.max = point_info.temp_limit[1] - point_info.temp_limit[0];
				this.min = -(this.max);
			}
		}

		this.state = {
			operator: operator,
			value: value,
		}
	}

	handleChangeValue = (val) => {
		this.setState({ value: val });
		//let value = {};
		let value = this.condition_detail.value;
		value.ofset = val;
		this.props.handleChangeStat(this.state.operator, value);
	}

	handleChangeOperator = (op) => {
		this.setState({ operator: op })
		//let value = {};
		let value = this.condition_detail.value;
		value.ofset = this.state.value;
		this.props.handleChangeStat(op, value);
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
			marginTop: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		let step = 0.5;
		if (this.props.point_info != null) step = 1 / (Math.pow(10, this.props.point_info.ndp));

		const range = [];

		for (var i = this.min; i <= this.max; i += step) {
			if (parseFloat(this.state.value) == i) {
				range.push(<option selected value={i.toFixed(1)}>{i.toFixed(1)}</option>);
			} else {
				range.push(<option value={i.toFixed(1)}>{i.toFixed(1)}</option>);
			}
		}

		const operators = [];
		operators.push(<option selected value={'>'}>{'>'}</option>);
		operators.push(<option selected value={'<'}>{'<'}</option>);

		//Determine unit for MP
		let unit = "";
		if (this.props.offset_point_id != null) {
			if (window.app.state.point_list[this.props.offset_point_id] != null) {
				if(window.app.state.point_list[this.props.offset_point_id].type == 'Ac') { 
					unit = 'DEG';
				} else if (window.app.state.point_list[this.props.offset_point_id].unit != null) {
					unit = window.app.state.point_list[this.props.offset_point_id].unit;
				}
			}
		}

		// Determine device orientation
		let screen_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		let screen_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		let is_landscape = screen_width > screen_height;

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 5, marginLeft: 5, width: '40%' }}>
					<span>{this.props.receiver.getString('rt')}</span>
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', width: '15%' }}>
					<div style={{ width: is_landscape ? 50 : '100%', float: is_landscape ? 'right' : 'none' }}>
						<Select
							options={operators}
							value={this.state.operator}
							onSelect={this.handleChangeOperator}
						/>
					</div>
				</div>
				{/* 100 */}
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 20, width: '25%' }}>
					<Editbox
						id='rt_offset'
						inputStyle={{ marginTop: 0, minWidth: 'unset' }}
						inputType='number'
						onChange={(event) => this.handleChangeValue(event.target.value)}
						value={this.state.value}
					/>
				</div>
				<span id="unit" style={{ display: unit == "" ? 'none' : 'inline-block', width: '10%', marginTop: 5, textAlign: 'end' }}>{this.props.receiver.getString(unit)}</span>
			</div>
		)
	}
}